import React from "react";

class Cable extends React.Component {
    render() {

       const { name, length, location, visible, image, quantity } = this.props.details;

       var quantityX = "(x" + quantity + ")";

        return ( 
        <div className="cable" hidden={!visible}>
            
                <div className="cableImg">
                    <img src={image} alt={name}  />
                </div>
            
            <h3>{name}
            
            
            
            
            {quantity > 1 &&
                        <span className="quantitySpan">{quantityX}</span>
                    }
            
            
            </h3>


            <div id="cableLength">
                <h5>Length</h5>
                <p>{length.toString()}-foot</p>
            </div>
           
            
          <div id="cableLocation">
            <h5>Location</h5>
            <p>{location.toString()}</p>
          </div>
            
        </div>
        )
    }
}

export default Cable;


// WEBPACK FOOTER //
// ./src/components/Cable.js